import EmptyResult from '@/app/[lng]/(home)/search/EmptyResult'
import { AdBannerScheduleType } from '@/app/types/adType'
import { CompanyResponse } from '@/app/types/companySearchType'
import LimitPagination from '@/components/LimitPagination'
import { convertNaNToOne } from '@/lib/formatUtils'
import { useParams, useRouter } from 'next/navigation'
import { useEffect, useOptimistic, useTransition } from 'react'
import CommonCompanyList from './CommonCompanyList'
import RetailCompanyFilterTags from './RetailCompanyTagFilter'
import CompaniesListBlockerCard from '@/app/[lng]/(home)/search/company-tab/CompaniesListBlockerCard'
const RetailCompanyResults = ({
  companyData,
  isLoading,
  adData,
}: {
  companyData: CompanyResponse
  isLoading: boolean
  adData: AdBannerScheduleType[]
}) => {
  const router = useRouter()
  const { lng, companyPageNo } = useParams<{
    lng: string
    companyPageNo: string[]
  }>()
  const [isPending, startTransition] = useTransition()
  const [optimisticPageNo, setOptimisticPageNo] = useOptimistic<number>(
    convertNaNToOne(Number(companyPageNo?.[0] || 1))
  )
  const isListingBlocked = () => {
    return (
      companyData?.status == 'warning' &&
      companyData?.uiHint == 'limit exhausted'
    )
  }
  const isDataEmpty =
    !isLoading &&
    companyData?.company?.length == 0 &&
    !isPending &&
    !isListingBlocked()

  const adFilter5 =
    adData?.filter((ad) => ad.ad_position.name === 'Ad Position 5')[0] ?? {}
  const adFilter6 =
    adData?.filter((ad) => ad.ad_position.name === 'Ad Position 6')[0] ?? {}
  const adFilter7 =
    adData?.filter((ad) => ad.ad_position.name === 'Ad Position 7')[0] ?? {}

  const adsData: AdBannerScheduleType[] = [adFilter5, adFilter6, adFilter7]
  const handlePageChange = (page: number) => {
    startTransition(() => {
      setOptimisticPageNo(page)
      router.push(`/${lng}/retails/companies/${page}`)
    })
  }
  useEffect(() => {
    // Pushing to page 1 when any Filter is Applied,
    // Because for the when applying filters the page count gets
    //  reducer if we are in page 10 only page 5 will exist

    if (companyData) {
      if (
        !companyData?.company?.length &&
        Number(companyPageNo?.[0] || 1) !== 1 &&
        !isListingBlocked()
      ) {
        handlePageChange(1)
      }
    }
  }, [companyData])
  return (
    <>
      <RetailCompanyFilterTags />
      {isListingBlocked() ? (
        <CompaniesListBlockerCard
          subscription={companyData?.current_subscription ?? ''}
        />
      ) : (
        <CommonCompanyList
          companyData={companyData}
          isCompanyDataLoading={isLoading}
          adsData={adsData}
        />
      )}
      <div className="mt-[35px] border-t-2 border-t-[#e6e6e6] border-solid mobile:mt-[10px]">
        {!isDataEmpty && (
          <LimitPagination
            currentPage={optimisticPageNo}
            pageCount={Math.ceil(companyData?.count / 10) || 1}
            visiblePages={5}
            onPageChange={(page) => handlePageChange(page)}
          />
        )}
      </div>

      {isDataEmpty && <EmptyResult searchTerm={''} />}
    </>
  )
}

export default RetailCompanyResults
